import { type InferResponseType, unwrap, withSignal } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of "Today" (ADR-299 §7): one read of crm, of one territory or of all, through the lens of some brands
// or of all (ADR-306).

const today = api.crm.today;

type Today = InferResponseType<typeof today.$get, 200>;
export type TodayCampaign = Today["campaigns"]["items"][number];
export type TodayAppointment = Today["appointments"]["items"][number];
export type QuietAccount = NonNullable<Today["quietAccounts"]>["items"][number];
export type TodaySend = NonNullable<Today["sending"]>[number];

const keys = { all: ["today"] as const };

export const todayQueries = {
  ...keys,

  of: (territory: string | undefined, brandOrgIds: string[] | undefined) =>
    queryOptions({
      queryKey: [...keys.all, { territory, brandOrgIds }],
      queryFn: ({ signal }) =>
        unwrap(
          today.$get(
            {
              query: {
                ...(territory && { territory }),
                ...(brandOrgIds && { brandOrgIds: brandOrgIds.join(",") }),
              },
            },
            withSignal(signal),
          ),
        ),
    }),
};
